export default __webpack_public_path__ + "images/kai-stone-0.svg";